import { useCallback, useEffect, useState } from "react";
import { Button, Card, Empty, Input, message, Modal, Popconfirm, Space, Table, Tag, Tooltip, Typography } from "antd";
import { DeleteOutlined, EditOutlined, EyeOutlined, FileTextOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { promptApi } from "../services/promptApi";
import PromptUserFilter from "../components/prompt/PromptUserFilter";
import { isAdminRole } from "../services/apiClient";

const { Text, Title } = Typography;
const statusColors = { completed: "green", failed: "red", running: "blue", partial: "orange", pending: "gold" };
export default function Scripts() {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inputTarget, setInputTarget] = useState(null);
  const [scriptText, setScriptText] = useState("");
  const [savingInput, setSavingInput] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const history = useHistory();
  const isAdmin = isAdminRole();
  const load = useCallback(() => { setLoading(true); promptApi.scripts.list(selectedUserId).then(setRuns).catch((error) => message.error(error.message)).finally(() => setLoading(false)); }, [selectedUserId]);
  useEffect(load, [load]);
  const openInput = async (item) => {
    setInputTarget(item);
    setScriptText("");
    try {
      const detail = await promptApi.scripts.get(item.id);
      setScriptText(detail.script || "");
    } catch (error) {
      message.error(error.message);
    }
  };
  const saveInput = async () => {
    if (!scriptText.trim()) return message.warning("Vui lòng nhập nội dung kịch bản");
    setSavingInput(true);
    try {
      const updated = await promptApi.scripts.updateInput(inputTarget.id, scriptText.trim());
      setRuns((items) => items.map((item) => item.id === updated.id ? { ...item, ...updated } : item));
      setInputTarget(null);
      message.success("Đã lưu nội dung kịch bản");
    } catch (error) { message.error(error.message); }
    finally { setSavingInput(false); }
  };
  const remove = async (id) => {
    try {
      await promptApi.scripts.remove(id);
      setRuns((items) => items.filter((item) => item.id !== id));
      message.success("Đã xóa kịch bản");
    } catch (error) {
      message.error(error.message);
    }
  };
  const columns = [
    ...(isAdmin ? [{ title: "USER", dataIndex: "ownerName", render: (value) => value || "-" }] : []),
    { title: "KỊCH BẢN", render: (_, item) => <Space><span className="script-list-icon"><FileTextOutlined /></span><div><Title level={5}>{item.title}</Title><Text type="secondary">{item.flowName} · phiên bản {item.flowRevision}</Text></div></Space> },
    { title: "CÁC BƯỚC", render: (_, item) => `${item.completedSteps}/${item.totalSteps} bước` },
    { title: "TRẠNG THÁI", dataIndex: "status", render: (status) => <Tag color={statusColors[status]}>{status}</Tag> },
    { title: "THỜI GIAN", dataIndex: "createdAt", render: (value) => new Date(value).toLocaleString("vi-VN") },
    { title: "", render: (_, item) => <Space><Tooltip title="Nhập kịch bản"><Button icon={<EditOutlined />} onClick={() => openInput(item)}>Nhập kịch bản</Button></Tooltip><Tooltip title="Xem chi tiết"><Button icon={<EyeOutlined />} onClick={() => history.push(`/scripts/${item.id}`)}>Xem chi tiết</Button></Tooltip><Popconfirm title="Xóa kịch bản này?" okText="Xóa" cancelText="Hủy" onConfirm={() => remove(item.id)}><Button className="flow-icon-button flow-delete-button" danger aria-label="Xóa kịch bản" icon={<DeleteOutlined />} /></Popconfirm></Space> },
  ];
  return <><div className="page-heading"><div><Title level={3}>Kịch bản</Title><Text type="secondary">Nhập nội dung, xem chi tiết và chạy từng node trong quy trình.</Text></div>{isAdmin && <div className="prompt-list-header-actions"><PromptUserFilter value={selectedUserId} onChange={setSelectedUserId} /></div>}</div><Card className="criclebox tablespace">{loading || runs.length ? <Table rowKey="id" loading={loading} columns={columns} dataSource={runs} pagination={false} /> : <Empty description="Chưa có kịch bản nào. Hãy tạo từ màn Flow để bắt đầu." />}</Card><Modal title={inputTarget ? `Nhập kịch bản: ${inputTarget.title}` : "Nhập kịch bản"} visible={Boolean(inputTarget)} onCancel={() => setInputTarget(null)} onOk={saveInput} confirmLoading={savingInput} okText="Lưu kịch bản" cancelText="Hủy" width={760}><Input.TextArea className="run-script-input" rows={12} value={scriptText} onChange={(event) => setScriptText(event.target.value)} placeholder="Nhập toàn bộ nội dung/kịch bản đầu vào cho các node level 1..." /></Modal></>;
}
